import { Part } from "@/models/Product";

export const partsMock: Part[] = [
  {
    id: "pt-1",
    title: "Lycoming O-360-A4M Engine",
    description: "Factory rebuilt Lycoming O-360 engine. Zero time since major overhaul. Complete with all accessories.",
    price: 32000,
    images: ["https://images.unsplash.com/photo-1565035010268-a3816f98589a?w=800"],
    category: "parts",
    subcategory: "Motoare",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2025-12-10",
    location: "București, România",
    status: "available",
    condition: "overhauled",
    partNumber: "LYC-O360-A4M",
    manufacturer: "Lycoming",
  },
  {
    id: "pt-2",
    title: "Hartzell 2-Blade Propeller",
    description: "Constant speed propeller for Cessna 182. Recently overhauled. Logbooks included.",
    price: 8500,
    images: ["https://images.unsplash.com/photo-1557800636-894a64c1696f?w=800"],
    category: "parts",
    subcategory: "Elice",
    sellerId: "s2",
    sellerName: "EuroAvion SRL",
    createdAt: "2025-11-20",
    location: "Cluj-Napoca, România",
    status: "available",
    condition: "overhauled",
    partNumber: "HC-C2YK-1BF",
    manufacturer: "Hartzell",
  },
  {
    id: "pt-3",
    title: "Garmin GTN 650Xi",
    description: "Brand new Garmin GTN 650Xi GPS/Nav/Comm. Latest software. Full warranty.",
    price: 12500,
    images: ["https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800"],
    category: "parts",
    subcategory: "Avionica components",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2026-01-05",
    location: "Timișoara, România",
    status: "available",
    condition: "new",
    partNumber: "010-02300-00",
    manufacturer: "Garmin",
  },
  {
    id: "pt-4",
    title: "Cleveland Main Gear Assembly",
    description: "Complete main landing gear assembly for Piper Cherokee. Includes brakes and wheels.",
    price: 4200,
    images: ["https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=800"],
    category: "parts",
    subcategory: "Tren aterizare",
    sellerId: "s3",
    sellerName: "RotorWing Romania",
    createdAt: "2025-10-15",
    location: "Brașov, România",
    status: "available",
    condition: "used",
    partNumber: "CLE-199-200",
    manufacturer: "Cleveland",
  },
];
